import { useLocation } from "react-router-dom";

import { Icon } from "@/components/common";
import { useTheme } from "@/contexts/ThemeContext";
import "./Topbar.css";

const SEGMENT_LABELS: Record<string, string> = {
  workspaces: "Workspaces",
  organizacoes: "Organizações",
  empresas: "Empresas",
  operacao: "Operação",
  contratos: "Contratos",
  faturamento: "Faturamento",
  admin: "Admin",
  plans: "Planos",
  account: "Conta",
  sessions: "Sessões",
};

function crumbsFor(pathname: string): string[] {
  const segs = pathname.split("/").filter(Boolean);
  if (segs.length === 0) return ["Início"];
  return segs.map((s, i) => {
    if (segs[0] === "workspaces" && i === 1) return "Detalhe";
    return SEGMENT_LABELS[s] ?? s;
  });
}

export function Topbar() {
  const { pathname } = useLocation();
  const { theme, toggleTheme } = useTheme();
  const crumbs = crumbsFor(pathname);

  return (
    <header className="topbar">
      <nav className="crumbs">
        {crumbs.map((c, i) => (
          <span key={i} className="crumb-wrap">
            {i > 0 && <span className="sep">/</span>}
            <span className={i === crumbs.length - 1 ? "crumb-current" : ""}>{c}</span>
          </span>
        ))}
      </nav>
      <div className="topbar-actions">
        <button
          className="icon-btn"
          onClick={toggleTheme}
          title={theme === "dark" ? "Tema claro" : "Tema escuro"}
          aria-label="Alternar tema"
        >
          <Icon name={theme === "dark" ? "sun" : "moon"} size={18} />
        </button>
      </div>
    </header>
  );
}
